 const getRandomId = () => {
    const r = Math.floor(Math.random() * 999999999999);
    if (!$('#r_' + r).length) {
        return 'r_' + r;
    } else {
        return getRandomId();
    }
}

 export default getRandomId